import { createContext } from 'react';

export type LeadCreationCtx = {
  showLeadCreateErrorAlert: boolean;
  showLeadCreateSuccessAlert: boolean;
  leadCreateError: string;
};

const LeadContext = createContext<LeadCreationCtx>({
  showLeadCreateErrorAlert: false,
  showLeadCreateSuccessAlert: false,
  leadCreateError: '',
});

export default LeadContext;
